export const isScrollable = (el) => {
    const { overflow, overflowX, overflowY } = window.getComputedStyle(el);
    return [overflow, overflowX, overflowY].some((style) => /auto|scroll/u.test(style));
};
//# sourceMappingURL=isScrollable.js.map